import React from 'react';
import { FlagId, flagIcons } from './generated/Flag';

export interface FlagProps {
  flagId: FlagId;
  width: number;
}

/**
 * FlagIcon in 4:3 aspect ratio.
 */
const FlagIcon = ({ flagId, width }: FlagProps) => {
  assertWidth(width);
  const Flag = flagIcons[flagId];
  return <Flag width={width} height={calculateHeight(width)} />;
};

const assertWidth = (width: number) => {
  if (width < 1)
    throw new Error(
      `FlagIcon was passed an invalid width of ${width}. Please provide a value >= 1.`
    );
};

/** Calculates height from a given width in 4:3 aspect ratio */
const calculateHeight = (width: number) => (width / 4) * 3;

export default FlagIcon;
